// project imports
import * as actionTypes from "./actions";

export const initialState = {
  buildin: "", // 内置感兴趣区
  draw: false, // 是否使用绘制图层
  selectedData: [], // 选择的年份
  submitClicked: false,
  geom: {},
  upload: false,
};

// CUSTOMIZATION REDUCER

const dataSelectionReducer = (state = initialState, action) => {
  let buildin;
  let selectedData;
  let draw;
  let geom;
  let upload;
  switch (action.type) {
    case actionTypes.BUILDIN:
      buildin = action.value;
      return {
        ...state,
        buildin,
      };
    case actionTypes.DRAW:
      draw = action.value;
      return {
        ...state,
        draw,
      };
    case actionTypes.UPLOAD:
      upload = action.value;
      return {
        ...state,
        upload,
      };
    case actionTypes.SELECTED_DATA:
      selectedData = action.value;
      return {
        ...state,
        selectedData,
      };
    case actionTypes.SET_SUBMIT_CLICKED:
      return {
        ...state,
        submitClicked: action.value,
      };
    case actionTypes.SUBMIT_GEOJSON:
      return {
        ...state,
        geom,
      };
    default:
      return state;
  }
};

export default dataSelectionReducer;
